<div class="p-4 overflow-auto h-[85vh]">

    <div class="flex justify-between -mt-4">
        <h2 class="text-xl font-semibold">Centers</h2>
        <p-button icon="pi pi-plus" label="Add Center" (click)="openAddModal()" class="mb-3"></p-button>
    </div>

    <p-table [value]="centers" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadCenters($event)" [loading]="loading">

        <ng-template pTemplate="header">
            <tr>
                <th>Center Name</th>
                <th>Center ID</th>
                <th>Client ID</th>
                <th>Bot Client ID</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-center>
            <tr>
                <td>{{ center.center_name }}</td>
                <td>{{ center.center_id }}</td>
                <td>{{ center.client_id }}</td>
                <td>{{ center.bot_client_id || 'N/A' }}</td>
                <td>{{ center.status || 'N/A' }}</td>
                <td>
                    <div (click)="setCenterData(center)">
                        <p-menu [tabindex]="undefined" #menu [model]="centerActionItem" [popup]="true"
                            appendTo="body"></p-menu>
                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td colspan="6" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="6" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>

<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-center 
      [clientId]="clientId" 
      (reload)="reload()" 
      (close)="closeAddModal()">
    </app-create-center>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showEditCenter">
  <p-dialog [(visible)]="showEditCenter" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-center 
      [clientId]="clientId" 
      [type]="'Update'" 
      [centerDataToEdit]="centerDataToEdit"
      (reload)="reload()" 
      (close)="showEditCenter = false">
    </app-create-center>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteCenter">
  <p-dialog [(visible)]="showDeleteCenter" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <app-delete-center
      [clientId]="clientId" 
      [centerDataToEdit]="centerDataToEdit"
      (reload)="reload()" 
      (close)="showDeleteCenter = false">
    </app-delete-center>
  </p-dialog>
</ng-container>